/**
 * Created by jonas on 2022-10-27.
 */
import {NineToFive} from "../NineToFive";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {NineToFiveWildSymbol} from "../reels/symbols/WildSymbol";
import {NineToFiveXWaysSymbol} from "../reels/symbols/XWaysSymbol";
import {NineToFiveXNudgeSymbol} from "../reels/symbols/XNudgeSymbol";
import {gsap} from "gsap"

export class RestoreUtils {

    public static DEFAULT_STARTUP_REELS = [
        ['M1', 'L2', 'L1', 'L3', 'M1', 'L2'],
        ['L4', 'M4', 'M3', 'L2', 'L1', 'L4'],
        ['L3', 'M1', 'L4', 'M4', 'M2', 'M1'],
        ['M3', 'L3', 'L2', 'L4', 'L1', 'L3'],
        ['L1', 'L2', 'M1', 'L3', 'M2', 'L1']
    ]

    constructor() {
    }

    private static restoreXNudgeSymbols():void {
        // We have to create a timeline since the "nudge" function on the reelModel class returns a tween.
        let tl:gsap.core.Timeline = gsap.timeline();
        (<NineToFiveXNudgeSymbol[]>NineToFive.baseGameReelView.getAllSymbols().filter((sym) => sym.symbolName == "XN"))
            .filter((sym) => sym.isActualSymbol)
            .forEach((sym) => {
                const reelNudges = sym.nudgeUp ? sym.reelPosition : 3 - sym.reelPosition;
                for(let i = 0; i < reelNudges; i++) {
                    tl.add(NineToFive.baseGameReelView.reelModels[sym.reelID].nudge(sym.nudgeUp));
                }

                sym.restore(sym.maxMultiplier - reelNudges);
            });
    }

    private static restoreXWaysSymbols():void {
        (<NineToFiveXWaysSymbol[]>NineToFive.baseGameReelView.getAllSymbols().filter((sym) => sym.symbolName == "XW"))
            .forEach((sym) => {
                // Ignore restore if we have a xNudge on the same reel as the xWays symbol will be nudged out.
                // I think this can only occur from outcome setter tho.
                if(NineToFive.baseGameReelView.reelModels[sym.reelID].getAllVisibleSymbols().find(s => s.symbolName == "XN")) {
                  return;
                }

                sym.restore();
            });
    }

    private static restoreWildSymbols():void {
        (<NineToFiveWildSymbol[]>NineToFive.baseGameReelView.getAllSymbols().filter((sym) => sym.symbolName == "W"))
            .forEach((sym) => {
               sym.restore();
            });
    }

    private static restoreSymbols():void {
        RestoreUtils.restoreXWaysSymbols();
        RestoreUtils.restoreXNudgeSymbols();
        RestoreUtils.restoreWildSymbols();
    }

    public static startupGame() {
        if (NineToFive.model.initData.isRestoreState) {
            if (NineToFive.model.data.nextMode == GameMode.FREESPIN) {
                if (NineToFive.model.data.mode == GameMode.NORMAL) {
                    RestoreUtils.restoreFreespinWithIntro();
                } else {
                    RestoreUtils.restoreFreespin();
                }
            } else if (NineToFive.model.data.nextMode == GameMode.FREESPIN_SUPER) {
                if (NineToFive.model.data.mode == GameMode.NORMAL) {
                    RestoreUtils.restoreSuperFreespinWithIntro();
                } else if (NineToFive.model.data.mode == GameMode.FREESPIN) {
                    RestoreUtils.restoreSuperFreespinUpgrade();
                } else {
                    RestoreUtils.restoreSuperFreespin();
                }
            }
        } else {
            RestoreUtils.normalStartUp();
        }
    }

    public static normalStartUp() {
    }

    public static restoreFreespinWithIntro() {
        RestoreUtils.restoreSymbols();
        NineToFive.keypadPlugin.setWin(NineToFive.model.data.accumulatedRoundWin, true, NineToFive.isWinBelowStake());
    }

    public static restoreFreespin() {
        RestoreUtils.restoreSymbols();
        NineToFive.backgroundElements.restore(NineToFive.model.data.mode);
        NineToFive.baseGameReelView.setFreeSpinsReelSet();
        NineToFive.baseGameReelView.freespinMultiplier.visible = true;
        NineToFive.baseGameReelView.freespinMultiplier.setVisualToFreespins();
        NineToFive.baseGameReelView.freespinMultiplier.restore(NineToFive.model.data.fsMultiplier, NineToFive.model.data.sfsNextMultiplier);
        NineToFive.keypadPlugin.setWin(NineToFive.model.data.accumulatedRoundWin, true, NineToFive.isWinBelowStake());
    }

    public static restoreSuperFreespinWithIntro() {
        RestoreUtils.restoreSymbols();
        NineToFive.keypadPlugin.setWin(NineToFive.model.data.accumulatedRoundWin, true, NineToFive.isWinBelowStake());
    }

    public static restoreSuperFreespinUpgrade() {
        RestoreUtils.restoreSymbols();
        NineToFive.backgroundElements.restore(NineToFive.model.data.mode);
        NineToFive.baseGameReelView.setFreeSpinsReelSet();
        NineToFive.baseGameReelView.freespinMultiplier.visible = true;
        NineToFive.baseGameReelView.freespinMultiplier.setVisualToFreespins();
        NineToFive.baseGameReelView.freespinMultiplier.restore(NineToFive.model.data.fsMultiplier, NineToFive.model.data.sfsNextMultiplier);
        NineToFive.keypadPlugin.setWin(NineToFive.model.data.accumulatedRoundWin, true, NineToFive.isWinBelowStake());
    }

    public static restoreSuperFreespin() {
        RestoreUtils.restoreSymbols();
        NineToFive.backgroundElements.restore(NineToFive.model.data.mode);
        NineToFive.baseGameReelView.setFreeSpinsReelSet();
        NineToFive.baseGameReelView.freespinMultiplier.visible = true;
        NineToFive.baseGameReelView.freespinMultiplier.setVisualToSuperFreespins();
        NineToFive.baseGameReelView.freespinMultiplier.restore(NineToFive.model.data.fsMultiplier, NineToFive.model.data.sfsNextMultiplier);
        NineToFive.keypadPlugin.setWin(NineToFive.model.data.accumulatedRoundWin, true, NineToFive.isWinBelowStake());
    }
}